import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import it from './locales/it.json';
import es from './locales/es.json';

const savedLang = localStorage.getItem('infismart_lang') || 'it';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      es: { translation: es }
    },
    lng: savedLang,
    fallbackLng: 'it',
    supportedLngs: ['it', 'es'],
    interpolation: { escapeValue: false }
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('infismart_lang', lng);
});

export default i18n;
